import { MdShoppingBasket } from "react-icons/md";
import styled from "styled-components";

import { darken, shade, tint } from "polished";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import ButtonPrimary from "../../components/ButtonPrimary";
import { device } from "../../styles/device";
import ButtonSecondary from "../../components/ButtonSecondary";

export const ContainerPageCart = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
  align-content: stretch;
  .produtcs-and-offers{
    display: block;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: stretch;
    min-height: calc(100vh - 659px);
  }
  .footer{
    border-top: solid 1px #E8E8E9
  }
`;

export const PageTitle = styled.h1`
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: ${props => props.theme.colors.neutral900};
  margin: 24px 0 0;
`;

export const ContentWrap = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

export const ShoppingIcon = styled(MdShoppingBasket)``;

export const AssistedSaleMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 24px;
  padding: 12px 20px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.colors.primary50};
  background: ${props => props.theme.colors.primary30};
  color: ${props => props.theme.colors.neutral900};
  font-size: 1.6rem;
  line-height: 20px;

  svg {
    flex-shrink: 0;
    color: ${props => props.theme.colors.primary};
  }
`;

export const NoRewardsProgramMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #ffefbc;
  border-radius: 12px;
  flex-wrap: wrap;
  border: 1px solid ${shade(0.1, "#ffefbc")};
  width: 100%;
  margin-top: 24px;
  position: relative;

  span {
    color: ${shade(0.5, "#ffefbc")};
    font-weight: 500;
    word-wrap: break-word;
    line-height: 20px;
    padding: 7px 5px;
    font-size: 1.6rem;
  }

  button {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 5px;
    border: none;
    background: none;

    svg {
      color: ${shade(0.5, "#ffefbc")};
      font-size: 2rem;
    }
  }

  a {
    text-decoration: underline;
    font-weight: 600;
  }

  @media (max-width: 900px) {
    width: 100%;
    margin-bottom: 0;

    span {
      font-size: 1.4rem;
    }
  }

  @media (max-width: 660px) {
    margin-bottom: 16px;
  }
`;

export const ButtonFooterWrap = styled.button`
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  width: 100%;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.primary};
  font-size: 1.6rem;
  font-weight: 700;
  border-radius: 999px;
  font-family: 'DM Sans', system-ui, sans-serif;
  border: none;
  transition: background 200ms ease;
  cursor: pointer;

  &:disabled{
    background: var(--neutral-200, #D0D1D3);
    color: var(--neutral-800, #44474E);
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: ${props => darken(0.08, props.theme.colors.primary)};
  }

  span {
    font-weight: 500;
    margin-left: 5px;
  }
`;

export const StyledButtonSecondary = styled(ButtonSecondary)`
  width: 100%;
  margin-top: 12px;
  border: none;

  &:hover {
    border: none;
    background: transparent;
    color: ${props => darken(0.1, props.theme.colors.primary)};
  }
`;

export const IconArrowRight = styled(IoIosArrowForward)`
  margin-left: 10px;
`;

export const EmptyCartWrap = styled.div`
  max-width: 486px;
  padding: 80px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  min-height: calc(100vh - 659px);
`;

export const EmptyCartIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: ${props => tint(0.85, props.theme.colors.primary)};
  margin-bottom: 24px;

  svg {
    width: 40px;
    height: 40px;
    color: ${props => props.theme.colors.primary};
  }
`;

export const KeepBuying = styled(Link)`
  font-size: 16px;
  padding: 10px 25px;
  text-decoration: none;
  margin-top: 15px;
  color: ${props => props.theme.colors.bodyLight};
  border: 1px solid ${props => props.theme.colors.bodyLight};
  font-family: 'DM Sans', system-ui, sans-serif;
  border-radius: 20px;
  transition: 0.2s;
  display: flex;
  align-items: center;
  span {
    margin-left: 5px;
  }
  &:hover {
    opacity: 0.8;
    box-shadow: 0px 1px 3px
      ${props => darken(0.03, props.theme.colors.bodyLight)};
  }
`;

export const PriceInfoWrap = styled.div`
  display: flex;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  align-items: stretch;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.neutral100};
  border-radius: 16px;
  box-shadow: var(--cards);
  padding: 24px;
  position: sticky;
  top: 24px;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: static;
  }

  .linkCompra {
    font-size: 14px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primary};
    padding: 20px;
    cursor: pointer;
  }
`;

export const PriceInfoContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  /* Desconto do Pix online, informativo abaixo do total (P-113) */
  &.pix-discount span.price-description,
  &.pix-discount span.price-value {
    padding: 0 0 8px;
    font-size: 14px;
    color: ${props => props.theme.colors.success};
  }

  :has(>.total) {
    border-top: solid 1px ${props => props.theme.colors.neutral100};
    margin-top: 12px;
    padding-top: 16px;
  }

  span.price-value {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    font-size: 16px;
    color: ${props => props.theme.colors.neutral900};
    font-weight: 700;
  }

  span.price-description {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    color: ${props => props.theme.colors.neutral600};
    font-size: 16px;
    font-weight: 500;
  }

  span.total {
    font-family: 'Sora', system-ui, sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: ${props => props.theme.colors.neutral900};
  }

  &.discount span.price-value {
    color: ${props => props.theme.colors.success};
  }

  /* Taxa é custo, não erro: cor normal; riscada (frete grátis) em cinza. */
  &.delivery-fee {
    span.price-value {
      color: ${props => props.theme.colors.neutral900};
    }

    span.price-value span {
      color: ${props => props.theme.colors.neutral400};
    }
  }
`;

export const OrderAgainButton = styled(Link)`
  max-width: 245px;
  width: 100%;
  height: 40px;
  border: none;
  color: ${props => props.theme.colors.primary};
  display: flex;
  margin: 20px 0 0;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  text-decoration: none;
  font-weight: 400;
  border: ${props => props.theme.colors.primary} 1px solid;
  border-radius: 3px;
  transition: background 200ms ease-in-out;

  :hover {
    color: ${props => props.theme.colors.bodyDark};
    background: ${props => darken(0.05, props.theme.colors.primary)};
  }

  @media (max-width: 660px) {
    margin: 5px 0 0 0;
  }
`;

export const TitleWrap = styled.div`
  margin-bottom: 20px;
  color: ${props => props.theme.colors.neutral900};
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  align-self: start;
`;

export const EmptyCartMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  h1 {
    font-family: 'Sora', system-ui, sans-serif;
    color: ${props => props.theme.colors.neutral900};
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }

  span {
    color: ${props => props.theme.colors.neutral600};
    font-size: 16px;
    line-height: 26.5px;
    text-align: center;
  }
`;

export const GoBackButton = styled(ButtonPrimary)`
  margin-top: 32px;
  width: 100%;
  border-radius: 999px;
  @media ${device.tablet} {
    max-width: 204px;
  }
`;

export const KeepBuyingLink = styled(Link)`
  margin-top: 24px;
  color: ${props => props.theme.colors.primary};
`;
